import React, { useEffect, useState } from 'react'
import CookieFunctions from '../functions/CookieFunctions'

import Summary from '../components/timeOff/Summary'
import { timeOffNames } from '../Constants'
import AllRequests from '../components/timeOff/AllRequests'

export default function TimeOffSummary() {
    const [summary, setSummary] = useState(null)
    const [history, setHistory] = useState(null)

    const driverType = CookieFunctions.getDriverType();
    const country = CookieFunctions.getCountry();

    const [type, setType] = useState(Object.keys(timeOffNames[driverType][country])[0]);

    function getSummary() {
        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        const formData = new FormData();

        formData.append("timeOffType", type)

        fetch("/api/drivers/timeOffSummary",
            {
                headers: myHeaders,
                method: 'POST',
                body: formData
            }
        ).then((res) => {
            if (res.ok) {
                return res.json()
            } else {
                throw new Error()
            }
        }).then((data) => {
            setSummary(data);
        })
    }

    function getHistory() {
        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        fetch("/api/drivers/history",
            {
                headers: myHeaders,
                method: 'POST',
            }
        ).then((res) => {
            if (res.ok) {
                return res.json()
            } else {
                throw new Error()
            }
        }).then((data) => {
            setHistory(data);
        })
    }

    useEffect(() => {
        getHistory()
    }, [])

    useEffect(() => {
        getSummary()
    }, [type])

    return (
        <>
            {summary ? <Summary summary={summary} setType={setType} /> : null}
            {history ? <AllRequests history={history} setHistory={setHistory} /> : null}
        </>

    )
}